document.addEventListener("DOMContentLoaded", function () {
	const sidebarMobileMenuToggle = document.querySelector('.mobile-menu-facets__open');
	const sidebarMenu = document.querySelector('.sidebar-menu-menu');
	const sidebarMenuToggle = document.querySelectorAll('.sidebarMenu-menu__item.has-children .icon-wrap');

	sidebarMobileMenuToggle.addEventListener('click', function(e){
		if (this.classList.contains('active')) {
			sidebarMenu.classList.remove('active')
			this.classList.remove('active');
		} else {
			sidebarMenu.classList.add('active')
			this.classList.add('active');
		}
	});

	sidebarMenuToggle.forEach((toggleMenu) => {
		toggleMenu.addEventListener('click', function(e) {
			const submenu = document.querySelector('.'+toggleMenu.getAttribute('data-dropdown-parent'));
			if (submenu.classList.contains('hidden')) {
				submenu.classList.remove('hidden');
				toggleMenu.classList.add('active')
			} else {
				submenu.classList.add('hidden');
				toggleMenu.classList.remove('active')
			}
		});
	});

});
